import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Paper as Card, Typography } from '@material-ui/core';
import { Radio } from '@material-ui/icons';
import HourSlider from './HourSlider';
import Moment from 'react-moment';
import Seo from '../Seo/Seo';

const styles = theme => ({
    root: {
        flexGrow: 1,
        marginTop: 10,
        padding: '8px 30px 30px',
        boxSizing: 'border-box',
        width: '100%',
        maxWidth: '100vw',
        overflowX: 'hidden',
        '@media (max-width: 959px)': {
            marginTop: 75,
        },
        '@media (max-width: 768px)': {
            padding: '16px',
            marginTop: 0,
        },
        '@media (max-width: 420px)': {
            padding: '14px',
            marginTop: 0,
        },
    },
    card: {

        textAlign: 'center',
        background: '#494A49',
        color: 'white',
        alignItems: 'center',
        justifyContent: 'center',

    },
    icon: {
        width: 35,
        height: 35,
        marginLeft: 10,
        marginBottom: -4,
    },
    h1: {
        textAlign: 'right',
        marginBottom: 8
    },
    pointView: {
        fontSize: 46
    },
    srOnly: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        width: 1,
        whiteSpace: 'nowrap',
    }
});

class Live extends Component {

    state = {
        pointTotal: null
    }

    componentDidUpdate(prevProps) {
        // Typical usage (don't forget to compare props):
        if (this.props.currentContest !== prevProps.currentContest) {
            this.getPointTotal(this.props.currentContest.id)
        }
    }

    getPointTotal = (value) => {
        this.props.dispatch({
            type: 'FETCH_POINT_TOTAL',
            payload: value
        })
    }

    componentDidMount() {
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }
        this.getContestDetails();
    }

    getContestDetails() {
        this.props.dispatch({
            type: 'FETCH_CURRENT_CONTEST',
            payload: this.props.user
        })
    }

    render() {

        const { classes } = this.props

        return (

            <div className={classes.root}>
                <Seo
                    title="Live Trivia Round | Trivia Weekend"
                    description="Track the live trivia round, monitor hour progress, and keep your team aligned in real time."
                    canonicalPath="/#/live"
                    ogType="website"
                />
                <Typography variant="h4" component="h1" className={classes.srOnly}>
                    Live Trivia Contest
                </Typography>
                <Grid container spacing={3}>
                    <HourSlider getPointTotal={this.getPointTotal} />
                </Grid>
            </div >
        )

    }

}

const mapStateToProps = state => ({
    user: state.user,
    team: state.team,
    currentContest: state.currentContest,
    pointTotal: state.pointTotal
});

export default withRouter(connect(mapStateToProps)(withStyles(styles)(Live)));
